import p from "react";
import { cls as s } from "../../helpers/cls.js";
import { forwardAsTagRef as h } from "../../helpers/forwardAsTagRef.js";
import { useUniqueId as O } from "../../hooks/useUniqueId.js";
var v = Object.defineProperty,
  w = Object.defineProperties,
  E = Object.getOwnPropertyDescriptors,
  i = Object.getOwnPropertySymbols,
  _ = Object.prototype.hasOwnProperty,
  f = Object.prototype.propertyIsEnumerable,
  m = (e, r, a) => r in e ? v(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  t = (e, r) => {
    for (var a in r || (r = {})) _.call(r, a) && m(e, a, r[a]);
    if (i) for (var a of i(r)) f.call(r, a) && m(e, a, r[a]);
    return e;
  },
  y = (e, r) => w(e, E(r)),
  x = (e, r) => {
    var a = {};
    for (var o in e) _.call(e, o) && r.indexOf(o) < 0 && (a[o] = e[o]);
    if (e != null && i) for (var o of i(e)) r.indexOf(o) < 0 && f.call(e, o) && (a[o] = e[o]);
    return a;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const N = h((e, r) => {
  const a = O("ds-chip-content"),
    o = e,
    {
      children: b,
      tag: l = "button",
      className: u,
      checked: d
    } = o,
    n = x(o, ["children", "tag", "className", "checked"]),
    c = l === "input";
  return p.createElement(c ? "span" : l, t(t({
    "data-ds-component": "DS-Chip",
    className: s({
      "olx-chip": !0,
      "olx-chip--input-wrapper": c
    }, u)
  }, l === "button" && {
    type: "button"
  }), !c && t({
    ref: r
  }, n)), c && p.createElement("input", t(t({
    ref: r,
    className: "olx-chip__native",
    checked: d
  }, !n["aria-label"] && {
    "aria-labelledby": a
  }), n)), p.createElement("span", y(t({}, c && {
    id: a
  }), {
    className: s({
      "olx-chip__content": !0,
      "olx-chip__content--checked": d,
      "olx-chip__content--disabled": e.disabled
    })
  }), b));
});
export { N as Chip };